//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import template from './bulk-selection-overlay.html';
import './bulk-selection-overlay.less';

import angular, { IPromise } from 'angular';
import _ from 'underscore';

import '../bulk-selection-item-details/bulk-selection-item-details';

export class BulkSelectionOverlay {
  public isAddedToGallery: boolean;
  public isAddedToConnect: boolean;
  public showInfoIcon: boolean;

  private onSelectItem: (properties: any) => {};
  private onUnselectItem: (cuid: any) => {};
  private isSelected: boolean;
  private itemDetails: any;
  private itemIdCallback: () => IPromise<string>;
  private onImageClicked: (properties: any) => void;
  private page: string;
  private context: string;
  private itemType: string;
  private onAddToGalleryCallback: () => any;

  public $onInit() {
    if (angular.isUndefined(this.showInfoIcon) || this.showInfoIcon === null) {
      this.showInfoIcon = true;
    }
  }

  public $onChanges() {
    if (this.itemDetails) {
      this.isAddedToGallery = _(this.itemDetails.distributionEndpoints).contains('Fanreel');
      this.isAddedToConnect = _(this.itemDetails.distributionEndpoints).contains('Connect');
    }
  }

  public openItem() {
    this.itemIdCallback().then((itemId) => {
      this.onImageClicked({
        itemId,
        itemType: this.itemType,
        page: this.page,
        context: this.context,
      });
    });
  }

  public toggleItem($event: MouseEvent) {
    $event.stopPropagation();

    this.itemIdCallback().then((itemId) => {
      const cuid = `${this.itemType}.${itemId}`;

      if (this.isSelected) {
        this.onUnselectItem({ cuid });
      } else {
        this.onSelectItem({
          cuid,
          onAddToGalleryCallback: this.onAddToGalleryCallback,
        });
      }
    });
  }
}

angular.module('curalate').component('bulkSelectionOverlay', {
  bindings: {
    context: '<',
    disableBulkActions: '<',
    showInfoIcon: '<?',
    isAnyItemSelected: '<',
    isSelected: '<',
    isSmallImage: '<',
    itemIdCallback: '&',
    itemType: '<',
    itemDetails: '<',
    onAddToGalleryCallback: '&',
    onImageClicked: '&',
    onSelectItem: '&',
    onUnselectItem: '&',
    page: '<',
    shouldShowGalleryText: '<',
    shouldShowConnectText: '<',
    hideItemDetails: '<',
    getTrueItemIdOnInit: '<',
  },
  controller: BulkSelectionOverlay,
  template,
});
